/* global process */

import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

import afterStoreSetup from './boot/after_store.js'
import { showBootError } from './boot/boot_error.js'
import messages from './i18n/messages.js'
import { piniaPersistPlugin } from './lib/persisted_state.js'
import { piniaPushNotificationsPlugin } from './lib/push_notifications_plugin.js'

import { piniaLanguagePlugin } from 'src/lib/language.js'
import { piniaStylePlugin } from 'src/lib/style.js'

const currentLocale = (window.navigator.language || 'en').split('-')[0]

const i18n = createI18n({
  // By default, use the browser locale, we will update it if neccessary
  locale: 'en',
  fallbackLocale: 'en',
  messages: messages.default,
})

messages.setLanguage(i18n.global, currentLocale)

;(async () => {
  const bootError = (e) => showBootError(e, i18n.global.t)
  window.bootError = bootError

  try {
    let storageError
    const pinia = createPinia()
    pinia.use(piniaPersistPlugin())
    pinia.use(piniaLanguagePlugin)
    pinia.use(piniaStylePlugin)
    pinia.use(piniaPushNotificationsPlugin)

    // Temporarily passing pinia  stores along with storageError result until migration is fully complete.
    return await afterStoreSetup({ pinia, storageError, i18n })
  } catch (e) {
    bootError(e)
  }
})()

// These are inlined by webpack's DefinePlugin
// biome-ignore-start lint: added in build process
window.___pleromafe_mode = process.env
window.___pleromafe_commit_hash = COMMIT_HASH
window.___pleromafe_dev_overrides = DEV_OVERRIDES
// biome-ignore-end lint: added in build process
